import React, { Component } from 'react';
import 'babel-polyfill';
import rawMarkup from '../../util/rawMarkup';
import EmbedIframe from './EmbedIframe';

import Thumbnail from '../Thumbnail.jsx';
import ArticleLink from '../ArticleLink.jsx';
import FeedPicture from '../NewsFeed/FeedPicture.jsx';

export default class Target extends React.PureComponent {

 
componentDidMount() {
}

componentDidUpdate() {
}

  render() {
   const { article, autoplay, isFirstArticle } = this.props;
   //const isVisibleCheck = this.props.isVisible;
   const isFirstArticleCheck = this.props.isFirstArticle;


   console.log(`isFirstArticle:  ` + isFirstArticle);
   
   let iframe_src = 'data-src';
   let iframe = 'https://www.viafree.dk/embed/sport/'+ `${article.slug}` +'?partnerId=627ae684-701a-418f-98a2-8bc11690a1d7&autoplay=' + `${this.props.autoplay}`; 
    
    return (
    	<div className={`box-frame ${this.props.isFirstArticle ? 'visible-frame' : 'transparent'}`}>
        {autoplay
        ?<EmbedIframe iframe={iframe} article={article} autoplay={this.props.autoplay} />
        :<Thumbnail className="thumbnail-big" data={article} maxItems={1}>
            <ArticleLink contentContainer={article}>
              <FeedPicture contentContainer={article} size={5}/>
            </ArticleLink>
          </Thumbnail>
        }
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/Target_prod_02062022.jsx